import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // Loading state - subtle, minimal
    return (
      <div
        data-testid="auth-loading"
        className="flex h-screen items-center justify-center"
      >
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <span className="inline-block h-2 w-2 rounded-full bg-foreground/40 animate-pulse" />
          Betöltés…
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
